import React, { useState, Fragment } from 'react';
import Select from 'react-select';
import _ from 'lodash';
import { Store } from '../../store';

import {
  toggleSubCategories,
  toggleLoading
} from '../../actions';

import {Row, Col} from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import { ProductTaxoIsin } from './ProductTaxoIsin';
import { MdAddCircleOutline, MdRemoveCircleOutline } from 'react-icons/md';

import './ProductTaxo.scss';
import { StarsRating } from '../StarsRating';

export interface ProductTaxoProps {
}

export function ProductTaxo({}: ProductTaxoProps) {
  // console.log("----> ProductTaxo");
  const { state, dispatch }: any = React.useContext(Store);

  const [isIconClass, setIsIconClass] = useState(false);


  // data taxonomies
  const defaultTaxo = [

    // { id: "general_category.raw", name: "Catégorie générale" },
    { id: "l1_category.raw", name: "Catégories" },
    { id: "geo_category.raw", name: "Zone géographique" },
    { id: "rating", name: "Notation Morning Star" },
    { id: "management_fee", name: "Frais courants" },
    { id: "performance_end_of_month_5_years", name: "Performances à 5 ans" },
    { id: "performance_end_of_month_10_years", name: "Performances à 10 ans" },
    { id: "advisor.raw", name: "Société de gestion" },
    // { id: "b4b_negociated_fee", name: "Fonds à 0%" },
    { id: "creation_date", name: "Antériorité des fonds" },
  ];

  const customStyles = {
    option: (provided: any, state: any) => ({
      ...provided,
      borderBottom: '1px solid #707070',
      backgroundColor: state.isSelected ? '#2D878D' : '#fff',
      color: state.isSelected ? '#fff' : '#707070',
      '&:hover': { backgroundColor: '#2D878D', color: '#fff' }
    }),
    control: (base: any, state: any) => ({
      ...base,
      cursor: 'pointer',
      boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(120, 194, 173, 0.25)" : 0,
      '&:hover': { Color: '#2D878D' },
      borderColor: state.isSelected ? '#2D878D' : '#707070',
      // width: '100% !important',
      height: '48px !important',
      paddingRight: '20px',
    }),
    menu: (base: any) => ({
      ...base,
      border: '1px solid #707070'
    }),
    indicatorSeparator: (base: any, state: any) => ({
      ...base,
      display: 'none',
      backgroundColor: state.isSelected ? '#2D878D' : '#707070',
      color: '#2D878D',
    }),
    dropdownIndicator: (base: any) => ({
      ...base,
      color: '#2D878D',
      position: 'absolute',
      right: '0',
      top: '6px',
    }),
    placeholder: (base: any) => ({
      ...base,
      color: '#000000',
      marginRight: '20px',
      position: 'initial',
      transform: 'inherit'
    }),
    singleValue: (provided: any, state: any) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';

      return {
        ...provided,
        opacity,
        transition
      };
    }
  }

  function CustomToggle({ children, eventKey }: any) {
    const onClickCustomToggle = useAccordionToggle(eventKey, () => {

      if (isIconClass === true) {
        setIsIconClass(false);
      } else {
        setIsIconClass(true);
      }

    });

    return (
      <button
        type="button"
        className={`btn btn-title text-primary custom-button`}
        onClick={onClickCustomToggle}
      >
        {children}
        {
          isIconClass ? <MdRemoveCircleOutline size={24}></MdRemoveCircleOutline> : <MdAddCircleOutline size={24}></MdAddCircleOutline>
        }

      </button>
    );
  }

  function onChangeFunc(select: any, id: string) {
    let current_select: any = select;
    if (current_select && state.filterSubCategories && state.filterSubCategories.length!= 0 ) {
      let is_exist: boolean = false;
      state.filterSubCategories.map(
        (filterKey: any) => {
          if(Object.keys(filterKey)[0] == current_select.filter) {
            is_exist = true;
          }
          if (is_exist) {
            toggleSubCategories({ key: null, doc_count: null, filter: current_select.filter }, state, dispatch)
          }
        }
      )
    }
    if (!current_select) {
      current_select = {
        key: null, doc_count: null, filter: id
      }
    }
    toggleSubCategories(current_select, state, dispatch);
    toggleLoading(true, dispatch);
  }

  function getCustomTaxoLabel(option: any) {
    switch (option.filter){
      case "performance_end_of_month_5_years": case "performance_end_of_month_10_years": case "management_fee":
        if(option.from) {
          if (option.to) {
            return `entre ${option.from}% et ${option.to}% (${option.doc_count})`;
          } else {
            return `Plus de ${option.from}% (${option.doc_count})`;
          }
        } else if (option.to) {
          return `Moins de ${option.to}% (${option.doc_count})`;
        }
      break;
      case "rating":
        return (
          <Fragment>
            <div style={{ display: "inline-flex" }}>
              <StarsRating stars={option.key}></StarsRating>
            </div>{" "}
            <div style={{ display: "inline-flex" }}>({option.doc_count})</div>
          </Fragment>
        );
      break;
      default:
        return`${option.key} (${option.doc_count})`;
    }
  }
  return (
    <div className="box flex-col">
      <Accordion>
        <div className="mb-3" style={{ borderBottom: "1px solid #2D878D" }}>
          <CustomToggle eventKey="0">
            <p className="h3" style={{ width: "85%" }}>
              Choisissez vos critères sur-mesure
            </p>
          </CustomToggle>
        </div>
        <Accordion.Collapse eventKey="0" className="mb-3">
          <div>
            <div className="filters-list">
              <Row>
                {defaultTaxo.map((taxo: any, index: number) => (
                  <Col xs="12" md="12" lg="12" className="mb-2" key={index}>
                    {taxo.id !== "creation_date" &&
                      state.tableTaxo[taxo.id] !== undefined &&
                      Object.keys(state.tableTaxo[taxo.id]).length !== 0 &&
                      state.tableTaxo[taxo.id].buckets !== undefined &&
                      state.tableTaxo[taxo.id].buckets.length !== 0 && (
                        <Select
                          isClearable={true}
                          isSearchable={false}
                          // isMulti
                          styles={customStyles}
                          placeholder={taxo.name}
                          scrollAfterSelection={false}
                          options={state.tableTaxo[taxo.id].buckets
                            .filter((i: any) => i.doc_count >= 1 && i.key !="-" && i.key !="")
                            .map((i: any) => ({ ...i, filter: taxo.id }))}
                          getOptionLabel={(option: any) =>
                            getCustomTaxoLabel(option)
                          }
                          getOptionValue={(option: any) => option.key}
                          onChange={(e: any) => onChangeFunc(e, taxo.id)}
                        />
                      )}
                    {taxo.id === "creation_date" &&
                      state.tableTaxo[taxo.id] !== undefined &&
                      Object.keys(state.tableTaxo[taxo.id]).length !== 0 &&
                      state.tableTaxo[taxo.id].buckets !== undefined &&
                      state.tableTaxo[taxo.id].buckets.length !== 0 && (
                        <Select
                          isClearable={true}
                          // isMulti
                          isSearchable={false}
                          styles={customStyles}
                          placeholder={taxo.name}
                          scrollAfterSelection={false}
                          options={state.tableTaxo[taxo.id].buckets
                            .filter((i: any) => i.doc_count >= 1 && i.key !="-" && i.key !="")
                            .map((i: any) => ({ ...i, filter: taxo.id }))
                            .sort()}
                          getOptionLabel={(option: any) =>
                            `${option.key_as_string} (${option.doc_count})`
                          }
                          getOptionValue={(option: any) => option.key_as_string}
                          onChange={(e: any) => onChangeFunc(e, taxo.id)}
                        />
                      )}
                  </Col>
                ))}
              </Row>
            </div>
            <div className="container-isin">
              <ProductTaxoIsin></ProductTaxoIsin>
            </div>
          </div>
        </Accordion.Collapse>
      </Accordion>
    </div>
  );
}
